import React from 'react';
const testimonials = [{
  avatar: 'SR',
  quote: 'Hice el Neuro-Dump por primera vez un martes a las 11 de la noche. El miércoles dormí de corrido 7 horas. Hacía 3 años que no pasaba eso.',
  name: 'Silvana R.',
  location: 'Mendoza · Ansiedad crónica'
}, {
  avatar: 'FM',
  quote: 'El módulo de neurociencia me cambió todo. Dejar de sentirme roto y empezar a entender que era biología fue el primer paso real.',
  name: 'Federico M.',
  location: 'Buenos Aires · Rumiación nocturna'
}, {
  avatar: 'LC',
  quote: 'Los scripts del Bono 3 los pegué en la mesita de noche. Ahora cuando mi mente empieza el loop, tengo la respuesta lista.',
  name: 'Laura C.',
  location: 'La Plata · Insomnio por ansiedad'
}, {
  avatar: 'PA',
  quote: 'Compré la opción completa. El Protocolo de 90 Días me está cambiando la vida de una forma que no esperaba. No es solo dormir mejor. Es vivir diferente.',
  name: 'Pablo A.',
  location: 'Rosario · Ansiedad generalizada'
}];
export function Testimonials() {
  return <section className="bg-navy py-12 md:py-24 px-4 text-cream-white" data-id="element-405">
      <div className="max-w-6xl mx-auto" data-id="element-406">
        <h2 className="font-display font-bold text-cream-white text-3xl mb-16 text-center" data-id="element-407">
          ❤️ Lo que dicen quienes ya lo tienen
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-408">
          {testimonials.map((test, i) => <div key={i} className="bg-white/10 border border-gold/25 p-8 rounded-xl border-l-[3px] border-l-gold" data-id="element-409">
              <div className="flex items-center gap-4 mb-6" data-id="element-410">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-sage-dark font-sans font-bold text-lg" data-id="element-411">
                  {test.avatar}
                </div>
                <div data-id="element-412">
                  <div className="flex gap-1 text-gold mb-1" data-id="element-413">
                    {[...Array(5)].map((_, j) => <span key={j} data-id="element-414">⭐</span>)}
                  </div>
                  <p className="font-sans font-bold text-gold text-sm" data-id="element-415">
                    {test.name}
                  </p>
                  <p className="font-sans font-light text-cream-white/60 text-xs" data-id="element-416">
                    {test.location}
                  </p>
                </div>
              </div>
              <p className="text-cream-white font-sans leading-relaxed" data-id="element-417">
                "{test.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}